import { createAsyncThunk } from '@reduxjs/toolkit';

import { sendSentryClientErrorOnce } from 'shared/lib/sendSentryClientError';

import { stTrackingApi } from '../stTracking.query';

type TSendStLeadPostbackThunkPayload = {
  transactionId: string | null | undefined;
  fullName?: string;
  mobilePhone?: string;
  scorePoint?: string;
};

export const sendStLeadPostbackThunk = createAsyncThunk<void, TSendStLeadPostbackThunkPayload>(
  'stTracking/sendStLeadPostbackThunk',
  async ({ transactionId, fullName, mobilePhone, scorePoint }, { dispatch }) => {
    if (!transactionId) {
      return;
    }

    try {
      await dispatch(
        stTrackingApi.endpoints.stTrackingPostback.initiate({
          transactionId,
          goalName: 'lead',
          fullName,
          mobilePhone,
          scorePoint,
        }),
      ).unwrap();
    } catch (error) {
      sendSentryClientErrorOnce('sendStLeadPostbackThunk', error);
    }
  },
);
